import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

// This is saved in browser's local storage.
//
// Be careful changing this structure, it can break
// the currently persisted state in client's browsers.
//
// https://zustand.docs.pmnd.rs/middlewares/persist#persisting-a-state-through-versioning-and-migrations
type GeneralConfigStoreState = {
  shouldShowWelcomeAlert: boolean;
};

type GeneralConfigStoreActions = {
  actions: {
    setShouldShowWelcomeAlert: (value: boolean) => void;
  };
};

type GeneralConfigStore = GeneralConfigStoreState & GeneralConfigStoreActions;

const defaultState: GeneralConfigStoreState = {
  shouldShowWelcomeAlert: true,
};

export const generalConfigStore = create<GeneralConfigStore>()(
  persist(
    devtools(
      (set) => ({
        ...defaultState,
        actions: {
          setShouldShowWelcomeAlert: (value: boolean) => {
            set({ shouldShowWelcomeAlert: value });
          },
        },
      }),
      {
        name: "general-config-store",
        enabled: !import.meta.env.PROD,
      },
    ),
    {
      name: "general-config-store",
      // Only save the state, dismiss the actions
      partialize: (state) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { actions, ...rest } = state;
        return rest;
      },
    },
  ),
);

export const useGeneralConfigShouldShowWelcomeAlert = () =>
  generalConfigStore((state) => state.shouldShowWelcomeAlert);

export const useGeneralConfigActions = () =>
  generalConfigStore((state) => state.actions);
